import { SET_BANK_LIST, SET_BANK_SELECTED } from '@/store/constants/eft'

export default {
  [SET_BANK_LIST]: (state, bankList) => { state.bankList = bankList },
  [SET_BANK_SELECTED]: (state, bankSelected) => { state.bankSelected = bankSelected }
}
